/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'prop-types'
], (React, PropTypes) => {

	/**
	* @class GridContentRenderer
	* @classdesc React component to display grid cell content consisting of a value and an optional shape
	*/
	class GridContentRenderer extends React.Component {

		constructor(props) {
			super(props);
		}

		render() {
			const { displayValue, iconsFeature, shapeId } = this.props;
			const isShapeCol = 'shapeId' in this.props;
			const classNames = ['dashboard-text-cell'];
			if (isShapeCol) {
				classNames.push('grid-shape-right');
				if (!shapeId) {
					classNames.push('noShape');
				}
			}
			return <React.Fragment>
				<div className={classNames.join(' ')}>{displayValue}</div>
				{shapeId &&
					<svg className="dashboard-grid-shape"><use xlinkHref={`#${iconsFeature.getIcon(shapeId).id}`}/><title>{shapeId}</title></svg>
				}
			</React.Fragment>;

		}

	}

	GridContentRenderer.propTypes = {
		/** The value to display in the cell*/
		displayValue: PropTypes.string.isRequired,
		/** The optional shape id to render in the cell.*/
		shapeId: PropTypes.string,
		iconsFeature: PropTypes.shape({
			getIcon: PropTypes.func.isRequired
		}).isRequired
	};

	return GridContentRenderer;
});
